const rooster = {
  container: {
    width: '1000px',
    margin: '0 auto',
    position: 'relative',
  },
  helpButtonContainer: {
    position: 'relative',
    marginLeft: 'auto',
    right: 0,
    width: '88px',
    marginBottom: '35px',
  },
}

const tops = {
  container: {
    width: '1040px',
    margin: '0 auto',
    position: 'relative',
    padding: '0 20px',
  },
  helpButtonContainer: {
    position: 'relative',
    marginLeft: 'auto',
    right: 0,
    width: '88px',
    marginBottom: '35px',
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ?
  tops :
  rooster



// WEBPACK FOOTER //
// ./src/components/Settings/styles/MessageSettings.js